var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"branch-select"},[_c('model-list-select',{attrs:{"list":_vm.pickList,"value":_vm.selectedObj,"option-value":"id","custom-text":_vm.optionText,"placeholder":_vm.placeholderText,"is-disabled":_vm.disabled},on:{"input":_vm.onPick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }